import { render, staticRenderFns } from "./PolicyCoverageCapitalForm.vue?vue&type=template&id=71509b48&"
import script from "./PolicyCoverageCapitalForm.vue?vue&type=script&lang=js&"
export * from "./PolicyCoverageCapitalForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports